// @mui
import { Box, Container, Stack } from '@mui/material';
// components
import { FeatureWidget, ContactWidget } from '../../sections/web/home';
import { ServiceWidget } from '../../sections/web/service';
import { SectionHeader } from '../../sections/web/common';
import { Seo } from '../../components/seo';

// ----------------------------------------------------------------------

export default function ServicePage() {
  return (
    <>
      <Seo
        title="Healthcare Licensing Services in UAE"
        description="Explore ASAP healthcare licensing services — DHA, MOH and HAAD registration support, exam preparation and document guidance for GCC applicants."
        path="/services"
      />

      <Box sx={{ bgcolor: 'background.default' }}>
        <Container maxWidth="xl" sx={{ py: { xs: 4, md: 6 } }}>
          <SectionHeader
            eyebrow="The best choice for your career"
            title="Our Services"
            titleComponent="h1"
            description="Structured programmes for DHA, MOH, HAAD and other Prometric exams, with study material, practice questions and mentor support."
          />

          <Stack spacing={{ xs: 5, md: 8 }}>
            <ServiceWidget />

            <FeatureWidget />

            <ContactWidget />
          </Stack>
        </Container>
      </Box>
    </>
  );
}
